module.exports = __webpack_public_path__ + "static/media/partners-image-8.38b6ca88.svg";